import DatePickerCustom from "components/Common/DatePickerCustom";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import { useRole } from "components/Hooks/UserHooks";
import SVGImageDefault from "components/Images/SVGImageDefault";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  APP_TYPE_OPTIONS,
  COLOR_BAR_LIST_PARTNER_STATUS,
  LIST_OPTION_BAR_LIST_PARTNER_STATUS
} from "helpers/constans";
import { formatDateStringToUTC, formatNumberWithCommas } from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { getBarStatistics } from "../../../store/thunks";
import noImage1 from "../../../assets/images/no-image.jpg";
import ModalPreview from "components/Common/ModalPreview";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import { Option } from "api/types/_public";
import DropdownOption from "components/Common/DropdownOption";
import DropdownOptionApp from "components/Common/DropdownOptionApp";
import ModalUVLog from "./ModalUVLog";

const SORT_BY_DEFAULT = "pv";
const ORDER_BY_DEFAULT = "DESC";

registerLocale("en", en);
registerLocale("ko", ko);

const Statistic = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const APP_TYPE_OPTIONS_LANG = APP_TYPE_OPTIONS?.map(
    (item: any) => ({ value: item?.value, label: t(item?.label) })
  );

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, SORT_BY_DEFAULT),
    order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
    start_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    end_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    app_type: withDefault(StringParam, `${APP_TYPE_OPTIONS_LANG[0]?.value}`),
  });

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Statistic;

  const ManagementProperties = createSelector(selectLayoutState, (state) => ({
    statistics: state.dailyBarStatistics,
    isStatisticSuccess: state.isDailyBarStatisticSuccess,
    isStatisticLoading: state.isDailyBarStatisticLoading,
    error: state.error,
  }));

  const { statistics, isStatisticLoading } = useSelector(ManagementProperties);
  const [isCallAllOptionLoading, setIsCallAllOptionLoading] =
    useState<boolean>(true);

  const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
  const [startDate, endDate] = dateSearch;

  const [appTypeSearch, setAppTypeSearch] = useState<Option | null>(APP_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.app_type)) || null);


  useEffect(() => {
    dispatch(getBarStatistics(query));
  }, [JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      app_type: appTypeSearch?.value || '',
      start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
      end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
      time_request: + new Date()
    });
  };

  const resetData = () => {
    const queryNew = {
      ...query,
      start_date: `${moment().format("Y-MM-DD")}`,
      end_date: `${moment().format("Y-MM-DD")}`,
      sort_by: SORT_BY_DEFAULT,
      order_by: ORDER_BY_DEFAULT,
      app_type: `${APP_TYPE_OPTIONS_LANG[0]?.value}`,
      time_request: +new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setAppTypeSearch(APP_TYPE_OPTIONS_LANG[0]);
    setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
  };

  const [linkImage, setLinkImage] = useState<any>(null);
  const onCloseImageClick = () => {
    setLinkImage(null);
  };



  const [infoModalUVLog, setInfoModalUVLog] = useState<{ user_ids: string, bar_id: string, bar_name: string, start_date: string, end_date: string } | null>(null);

  const handleCloseModalUVLog = () => {
    setInfoModalUVLog((_prev) => null);
  };


  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <div style={{ width: '40' }}>
              {item?.text_row ? '' : ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Store"),
        accessor: "bar",
        filterable: true,
        sortable: false,
        thClass: "align-middle text-start",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const _status = LIST_OPTION_BAR_LIST_PARTNER_STATUS?.find((s: any) => String(s?.value) === String(item?.bar?.partner_status))?.label || "";
          return (
            <>
              {!!item?.text_row ? <div>{item?.text_row}</div> : <div className="d-flex align-items-center box-inventory-button-edit" style={{ minWidth: '200px' }}>
                <div className="flex-shrink-0 me-2 position-relative">
                  {!!item?.bar ? (
                    <img src={item?.bar?.thumbnail_url || ''} alt={item?.bar?.title} className="avatar-sm object-fit-cover cursor-pointer"
                      onClick={() => {
                        setLinkImage({
                          urls: [{ url: item?.bar?.thumbnail_url, type: 'image' }],
                          content: { title: item?.bar?.title || '', content: item?.bar?.title }
                        });
                      }}
                      style={{ backgroundColor: 'rgb(234 234 234 / 49%)', borderRadius: '5px' }} />) : (
                    <SVGImageDefault style={{ height: '48px' }} />
                  )}
                </div>
                <div>
                  <div className="ms-2 d-flex justify-content-start align-items-center">
                    <span style={{ fontWeight: '600' }} className="fs-15"> {item?.bar?.title || ''}</span>
                    <span
                      className={`rounded-pill badge ms-2 bg-${COLOR_BAR_LIST_PARTNER_STATUS[item?.bar?.partner_status] || "secondary"}`}
                    >
                      {t(_status)}
                    </span>
                  </div>
                  <div className="ms-2 text-muted fs-13 mt-0 mt-md-1" style={{ maxWidth: '400px' }}>
                    <a
                      href={`https://www.google.com/maps/search/${item?.bar?.lat},${item?.bar?.long}/@${item?.bar?.lat},${item?.bar?.long},17z?entry=ttu`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-muted text-underline-hover"
                    >
                      {item?.bar?.address || ''}
                    </a>
                  </div>
                </div>
              </div>}
            </>
          );
        },
      },
      {
        Header: '',
        accessor: "_",
        filterable: true,
        sortable: true,
        thClass: "align-middle text-end",
        thWidth: 50,
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end">
              </div>
            </>
          );
        },
      },
      {
        Header: t('Clicks'),
        accessor: "clicks",
        thClass: 'text-end',
        filterable: false,
        sortable: false,
        thWidth: 240,
        thComponent: () => (
          <table>
            <thead>
              <tr>
                <th className="text-center pb-1 none-sticky" colSpan={4}>
                  {t('Clicks')}
                </th>
              </tr>
              <tr>
                <tr>
                  <th className="text-center px-0 py-1 cursor-pointer none-sticky" style={{ width: '120px' }}
                  >
                    <span onClick={() => {
                      handleChangeSorting({
                        sort_by: "pv",
                        order_by: query?.order_by === "DESC" && query?.sort_by === "pv" ? "ASC" : "DESC",
                      });
                    }}>
                      {t('PV')}
                      {query?.sort_by === "pv" && (
                        <span
                          style={{
                            display: "inline-flex",
                            justifyContent: "center",
                            width: "12px",
                            marginLeft: "2px",
                            verticalAlign: "middle",
                          }}
                        >
                          {query?.order_by === "DESC" ? (
                            <i className={`ri-arrow-down-line fs-13 text-primary`} />
                          ) : (
                            <i
                              className={`ri-arrow-up-line fs-13 text-primary`}
                            />
                          )}
                        </span>
                      )}
                    </span>
                  </th>
                  <th className="text-center px-0 py-1 cursor-pointer none-sticky" style={{ width: '120px' }}
                  >
                    <span onClick={() => {
                      handleChangeSorting({
                        sort_by: "uv",
                        order_by: query?.order_by === "DESC" && query?.sort_by === "uv" ? "ASC" : "DESC",
                      });
                    }}>
                      {t('UV')}
                      {query?.sort_by === "uv" && (
                        <span
                          style={{
                            display: "inline-flex",
                            justifyContent: "center",
                            width: "12px",
                            marginLeft: "2px",
                            verticalAlign: "middle",
                          }}
                        >
                          {query?.order_by === "DESC" ? (
                            <i className={`ri-arrow-down-line fs-13 text-primary`} />
                          ) : (
                            <i
                              className={`ri-arrow-up-line fs-13 text-primary`}
                            />
                          )}
                        </span>
                      )}
                    </span>
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div className="d-flex text-center">
              <div style={{ width: '120px' }}>{formatNumberWithCommas(item?.pv)}</div>
              {!!item?.text_row ? <div style={{ width: '120px', borderLeft: "1px solid #eaeaea" }} >{formatNumberWithCommas(item?.uv)}</div> : <div style={{ width: '120px', borderLeft: "1px solid #eaeaea" }} className="hover-underline cursor-pointer" onClick={
                () => {
                  setInfoModalUVLog((_prev) => ({
                    user_ids: (item?.user_ids)?.join(','),
                    bar_id: item?.bar_id,
                    bar_name: item?.bar?.title,
                    start_date: query?.start_date,
                    end_date: query?.end_date,
                  }));
                }
              }>{formatNumberWithCommas(item?.uv)}</div>}
            </div>
          );
        },
      },
      {
        Header: '',
        accessor: "___",
        filterable: true,
        sortable: true,
        thClass: "align-middle text-end",
        thWidth: 50,
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end">
              </div>
            </>
          );
        },
      },
    ],
    [i18n?.language, userPermissions, query?.media_id, query?.start_date, query?.end_date]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, sort_by: sortBy?.sort_by, order_by: sortBy?.order_by };
    }, "push");
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  }

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        setIsCallAllOptionLoading((_prev) => false);
      } catch (error: any) {
        setIsCallAllOptionLoading((_prev) => false);
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  useEffect(() => {
    document.title = `${t("사용자 통계 ")} - ${t("Home")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  // const categories = useMemo(() => {
  //   return statistics?.items?.map((item: any) => item?.date).reverse() || [];
  // }, [statistics?.items, i18n?.language]);

  // const series = useMemo(() => {
  //   const obChart =
  //     statistics?.items?.reduce(
  //       (ob: any, item: any) => {
  //         ob.visits?.push(
  //           Number(String(item?.totalUserVisits).replace(/,/g, ""))
  //         );
  //         ob.registrations?.push(
  //           Number(String(item?.totalUserRegistered).replace(/,/g, ""))
  //         );
  //         ob.withdrawals?.push(
  //           Number(String(item?.totalUserWithdrawals).replace(/,/g, ""))
  //         );
  //         ob.installs?.push(
  //           Number(String(item?.totalUserInstalls).replace(/,/g, ""))
  //         );
  //         return ob;
  //       },
  //       {
  //         visits: [],
  //         registrations: [],
  //         withdrawals: [],
  //         installs: [],
  //       }
  //     ) || [];
  //   return [
  //     {
  //       name: t("Number of installs"),
  //       type: "column",
  //       data: obChart?.installs?.reverse(),
  //     },
  //     {
  //       name: t("Number of registrations"),
  //       type: "column",
  //       data: obChart?.registrations?.reverse(),
  //     },
  //     {
  //       name: t("Number of installs"),
  //       type: "column",
  //       data: obChart?.installs?.reverse(),
  //     },
  //     {
  //       name: t("Number of withdrawals"),
  //       type: "line",
  //       data: obChart?.withdrawals?.reverse(),
  //     },
  //   ];
  // }, [statistics?.items, i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Store Statistics")} pageTitle={t("Home")} />
          <Row>
            <Col sm={12} md={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                className="ribbon-box right"
              >
                <div
                  className="ribbon round-shape"
                  style={{
                    background: "rgb(40 99 213)",
                    fontWeight: 300,
                    fontSize: "0.8rem",
                    top: "11px",
                  }}
                >
                  {t("This data is analyzed per 10 mins")}
                </div>
                <CardHeader
                  className="border-0"
                  style={{ borderRadius: "30px" }}
                >
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={statistics?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <Row className="g-4 align-items-center mt-0">
                    <Col sm={6} md={3} xl={3} xxl={3} className='mt-3 mt-md-2'>
                      <LabelWrapper label={t('App')} isShow={true}>
                        <DropdownOptionApp
                          name=""
                          dataList={APP_TYPE_OPTIONS_LANG}
                          placeholder={`${t("App")}...`}
                          className="search-filter-category-type dropdown-status-rounded"
                          classNamePrefix="name-prefix"
                          initialValue={appTypeSearch || null}
                          onChangeSelect={(e: any) => setAppTypeSearch(e)}
                          isHasOptionAll={true}
                          optionAll={{ label: t('All'), value: '' }}
                        />
                      </LabelWrapper>
                    </Col>
                    <Col sm={6} md={3} xl={3} xxl={3} className='date-picker-wrapper-custom mt-3 mt-md-2'>
                      <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                        <DatePickerCustom
                          placeholder={`${t('Start Date')} - ${t('End Date')}`}
                          startDate={startDate || null}
                          endDate={endDate || null}
                          onChangePicker={handleChangePicker}
                          showOptions={[
                            'today',
                            'yesterday', 'two_day_ago',
                            'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                            'this_week', 'last_week',
                            'this_month', 'last_month',
                          ]}
                          maxDate={new Date(new Date().setDate(new Date().getDate()))}
                        />
                      </LabelWrapper>
                    </Col>
                    <Col sm={12} md={6} xl={6} xxl={6} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-md-start mt-3 mt-md-2">
                      <div>
                        <button
                          type="button"
                          className="btn btn-primary me-2 "
                          onClick={searchData}
                          disabled={(isStatisticLoading)}
                        >
                          {t('Button Search')}
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary fs-14"
                          disabled={isStatisticLoading}
                          onClick={resetData}
                        >
                          <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                          {t('Button Reset')}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>

                <CardBody className="pt-3">
                  <TableContainer
                    className="custom-header-css"
                    divClass="table-responsive table-card"
                    tableClass="align-middle table-bordered-dashed table-have-first-row-is-total sticky-table-daily-statistics"
                    theadClass="table-light text-muted"
                    columns={columns}
                    data={
                      statistics?.items?.length
                        ? [
                          {
                            ...statistics?.total_data,
                            text_row: t("Sum"),
                          },
                          ...statistics?.items,
                        ]
                        : []
                    }
                    customPageSize={query.limit}
                    customPageIndex={query.page - 1}
                    totalRecords={statistics?.pagination?.total}
                    customPageCount={Math.ceil(
                      Number(statistics?.pagination?.total) / Number(query?.limit)
                    )}
                    handleChangePage={handleChangePage}
                    manualSorting={true}
                    sorting={{
                      sort_by: query.sort_by,
                      order_by: query.order_by,
                    }}
                    handleChangeSorting={handleChangeSorting}
                    isLoading={isStatisticLoading}
                    isShowPagination={true}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={false} limit={1} />
        </Container>


        <ModalUVLog
          isOpen={!!infoModalUVLog}
          params={infoModalUVLog}
          onClose={handleCloseModalUVLog}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default Statistic;
